import { Injectable } from '@angular/core';
import {MatDialogRef, MatDialog } from '@angular/material/dialog';

@Injectable(
  {providedIn: "root"}
)
export class DialogService {

    constructor(  public dialog: MatDialog) { }
    
    public openDialog(component:any,data:any, style={}): MatDialogRef<any> {
        const _data = {data:data, ...style};
        const dialogRef = this.dialog.open(component, _data);
        return dialogRef;
   
    }
      /**
   * Close previous opened dialog and open new one
   * @param data : data to show in dialog
   */
  public openErrorDialog(component:any,data:any, style={}): MatDialogRef<any> {
    this.dialog.closeAll();
    const _data = {data:data, ...style};
    const dialogRef = this.dialog.open(component, _data);
    return dialogRef;

}
}